<script>
  export default {
    name: "AppReflect"
  }
</script>

<template>
  <div class="reflection"></div>
</template>

<style>

.reflection {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 70%);
  border-radius: 50%;
  opacity: 0.6;
}

/* Animation scintillante */
@keyframes shimmer {
  0%, 100% {
    opacity: 0.2;
    transform: scale(0.8);
  }
  50% {
    opacity: 0.8;
    transform: scale(1);
  }
}

/* Mouvement horizontal et vertical */
@keyframes move {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(50px, 20px);
  }
  100% {
    transform: translate(-50px, 40px);
  }
}
</style>